export const UPLOAD_XML_EVENT = "upload-xml";
export const DELETE_DECLARANT_EVENT = "delete-declarant";
export const UPDATE_DECLARANT_EVENT = "update-declarant";
export const DELETE_SIGMA_EVENT = "delete-sigma";
export const DELETE_CREATED_EVENT = "delete-created";
export const FORCE_DELETE_DECLARANT_EVENT = "force-delete-declarant";
export const RESTORE_DECLARANT_EVENT = "restore-declarant";
export const CHANGE_TABLE_CELL_EVENT = "change-table-cell";
export const DELETED_ENTITY = "deleted-entity";

export const CHANGE_DEPARTMENTS_DATA_FIELD = "change-departments-data-field";
export const CHANGE_CUSTOM_GROUP_FIELD = "change:custom-group:field";

export const USER_LOADED = "user-loaded";
export const UPDATED_USER_SETTINGS = "updated-user-store";
export const USER_HAS_AUTHORIZED = "user-has-authorized";

export const UNAUTHORIZED_ACTION = "unauthorized-action";

// COLUMNS EVENTS
export const COLUMNS_POSITION_CHANGED = "columns-positions-changed";

// by-clients events
export const CHANGE_EXPOSED_FIELD = "by-clients-change-exposed-field";

export const CHANGE_EXPOSED_FIELD_IN_GROUP = "change-exposed-field-in-group";

// department-data events
export const CHANGE_EXPOSED_FIELD_IN_DEPARTMENTS_DATA =
  "departments-data-change-exposed-field";
export const CHANGE_EXPOSED_FIELD_IN_DEPARTMENTS_DATA_GROUP =
  "departments-data-change-exposed-field-in-group";
export const CHANGE_WARRANTY_CONVERT_IN_DEPARTMENTS_DATA =
  "departments-data-change-warranty-convert";

export const MAKE_ENCASHMENT = "make-encashment";

// cmrs
export const DELETE_CMR_ENTITY = "delete-cmr-entity";
export const DOWNLOAD_CMR = "download-cmr";
export const REFRESH_CMR_TABLE = "refresh-cmr-table";
export const DOWNLOAD_CMR_IN_DECLARANTS_TABLE =
  "download-cmr-in-declarants-table";

export const ENABLE_UPDATE_CMR_FORM = "enable-update-cmr-form";

export const SET_EDITING_KEY = "set-editing-key";
export const REMOVE_EDITING_KEY = "remove-editing-key";
export const ADD_NEW_ROW = "add-new-row";
export const DELETE_LOGISTIC_EVENT = "delete-logistic-entity";
export const SAVE_LOGISTIC_ENTITY = "save-logistic-entity";
export const UPDATE_LOGISTIC_ENTITY = "edit-logistic-entity";
export const DOWNLOAD_LOGISTIC_FILE = "download-logistic-file";
export const DELETE_LOGISTIC_FILE = "delete-logistic-file";

// Contracts
export const DELETE_CONTRACTS_EVENT = "delete-contracts-entity";
export const ADD_NEW_CONTRACTS_ROW = "add-new-contracts-row";
export const SAVE_CONTRACTS_ENTITY = "save-contracts-entity";
export const UPDATE_CONTRACTS_ENTITY = "edit-contracts-entity";
export const DOWNLOAD_CONTRACTS_FILE = "download-contracts-file";
export const DELETE_CONTRACTS_FILE = "delete-contracts-file";
export const SET_CONTRACTS_EDITING_KEY = "set-contracts-editing-key";
export const REMOVE_CONTRACTS_EDITING_KEY = "remove-contracts-editing-key";
